import { ContainerImportedRankingEntry } from 'models/ranking/importedRanking/entry/ContainerImportedRankingEntry';

export class ContainerImportedRankingEntryService {
	toModel(ranking) {
		return new ContainerImportedRankingEntry(ranking);
	}
}
